export const undoRedoConstants = {
  STORE_FEATURE_STATE: 'STORE_FEATURE_STATE',
  UNDO: 'UNDO',
  REDO: 'REDO',
};
